import { load as loadFacebook, signIn as signInFacebook } from "./facebook";
import { load as loadGoogle, signIn as signInGoogle } from "./google";
import { SocialCredentials } from "../models/auth.model";

const CREDENTIALS = {
  GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID || "1084276765898-a557i20q1vdel39tnoea1pahhqu573e8.apps.googleusercontent.com",
  FACEBOOK_CLIENT_ID: process.env.FACEBOOK_CLIENT_ID || "308783362635714"
};

let ready: boolean = false;

const init = async () => {
  await loadGoogle({ client_id: CREDENTIALS.GOOGLE_CLIENT_ID });
  await loadFacebook(CREDENTIALS.FACEBOOK_CLIENT_ID);
};

init().then(() => {
  ready = true;
});

const isReady = () => ready;

const getAccessToken = async (provider: "facebook" | "google"): Promise<SocialCredentials> => {
  if (!isReady()) {
    await init();
    ready = true;
  }
  let loginResult;
  switch (provider) {
    case "facebook":
      loginResult = await signInFacebook();
      if (loginResult.status === "connected") {
        return {
          provider,
          accessToken: loginResult.authResponse.accessToken
        };
      }
      break;
    case "google":
      loginResult = await signInGoogle();
      console.log(loginResult);
      return {
        provider,
        accessToken: loginResult.access_token
      };
  }

  return {
    provider,
    accessToken: ""
  };
};

export { getAccessToken };
